/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiH2hGet200Response } from '../models';
/**
 * H2hApi - axios parameter creator
 * @export
 */
export const H2hApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get h2h by id from Sportradar API
         * @param {string} homeId 
         * @param {string} awayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiH2hGet: async (homeId: string, awayId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'homeId' is not null or undefined
            assertParamExists('apiH2hGet', 'homeId', homeId)
            // verify required parameter 'awayId' is not null or undefined
            assertParamExists('apiH2hGet', 'awayId', awayId)
            const localVarPath = `/api/h2h/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (homeId !== undefined) {
                localVarQueryParameter['home_id'] = homeId;
            }

            if (awayId !== undefined) {
                localVarQueryParameter['away_id'] = awayId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * H2hApi - functional programming interface
 * @export
 */
export const H2hApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = H2hApiAxiosParamCreator(configuration)
    return {
        /**
         * Get h2h by id from Sportradar API
         * @param {string} homeId 
         * @param {string} awayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiH2hGet(homeId: string, awayId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiH2hGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiH2hGet(homeId, awayId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['H2hApi.apiH2hGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * H2hApi - factory interface
 * @export
 */
export const H2hApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = H2hApiFp(configuration)
    return {
        /**
         * Get h2h by id from Sportradar API
         * @param {H2hApiApiH2hGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiH2hGet(requestParameters: H2hApiApiH2hGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiH2hGet200Response> {
            return localVarFp.apiH2hGet(requestParameters.homeId, requestParameters.awayId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiH2hGet operation in H2hApi.
 * @export
 * @interface H2hApiApiH2hGetRequest
 */
export interface H2hApiApiH2hGetRequest {
    /**
     * 
     * @type {string}
     * @memberof H2hApiApiH2hGet
     */
    readonly homeId: string

    /**
     * 
     * @type {string}
     * @memberof H2hApiApiH2hGet
     */
    readonly awayId: string
}

/**
 * H2hApi - object-oriented interface
 * @export
 * @class H2hApi
 * @extends {BaseAPI}
 */
export class H2hApi extends BaseAPI {
    /**
     * Get h2h by id from Sportradar API
     * @param {H2hApiApiH2hGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof H2hApi
     */
    public apiH2hGet(requestParameters: H2hApiApiH2hGetRequest, options?: RawAxiosRequestConfig) {
        return H2hApiFp(this.configuration).apiH2hGet(requestParameters.homeId, requestParameters.awayId, options).then((request) => request(this.axios, this.basePath));
    }
}

